import { colors } from 'app-v2/design-systems'
import React, { type ReactNode, useState } from 'react'
import { Chevron } from '../../../../assets/icons'
import { useWindowDimensions } from '../../../utils'
import { breakpoints } from '../../../../assets/styles'
import styled from 'styled-components'
import { media } from '../../../../assets/styles'
import { SPACING } from '../../../../../app-v2/design-tokens'

type ExplanationItemProps = {
    title: ReactNode,
    children: ReactNode
}

export const ExplanationItem = ({ title, children }: ExplanationItemProps) => {
    const [open, setOpen] = useState(false)
    const { width: windowWidth } = useWindowDimensions()
    const isMedium = windowWidth <= breakpoints.medium
    return (
        <StyledExplanationItem>
            <StyledItemTitle
                href={'#'}
                onClick={e => {
                    e.preventDefault()
                    setOpen(open => !open)
                }}>
                {!isMedium && (
                    <Chevron
                        color={colors.bbqBrown}
                        direction={open ? 'down' : 'right'}
                    />
                )}
                {title}
                {isMedium && (
                    <Chevron
                        color={colors.bbqBrown}
                        direction={open ? 'up' : 'down'}
                    />
                )}
            </StyledItemTitle>

            <StyledItemDescription opened={open}>
                {children}
            </StyledItemDescription>
        </StyledExplanationItem>
    )
}

const StyledExplanationItem = styled.div`
    display: flex;
    border-bottom: 1px solid ${colors.bbq30};
    flex-direction: column;
`

const StyledItemTitle = styled.a`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: ${SPACING.M} ${SPACING.XXS} ${SPACING.M} 0;
    ${media.medium`
        justify-content: start;
        gap: ${SPACING.XXS};`}
`

const StyledItemDescription = styled.div`
    overflow: hidden;
    max-height: 0;
    padding: 0 ${SPACING.S};
    transition: max-height 0.2s, padding 0.2s;
    ${props =>
        props.opened &&
        `
        max-height: none; 
        padding: ${SPACING.XS} ${SPACING.S} 0;`}
`
